import { formataChave, formataValorSimulador } from "@/services/utils";
import ClearIcon from "@mui/icons-material/Clear";
import { Divider, Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { FieldArray, FormikProvider } from "formik";

export default function ItemPagamentoPix({ formik }) {
  return (
    <>
      {formik.values.pixs.length > 0 && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <Paper variant="outlined" sx={{ p: 1, pb: 2 }}>
            <FormikProvider value={formik}>
              <FieldArray
                name="pixs"
                render={() => (
                  <>
                    <Grid container spacing={1}>
                      <Grid size={12} align="center">
                        <img
                          src="/icon-pix2.png"
                          alt=""
                          style={{ height: "2.5rem" }}></img>
                      </Grid>
                    </Grid>
                    {formik.values.pixs.map((pix, index) => (
                      <Grid container spacing={1} key={`pix${index}`}>
                        <Grid size={12}>
                          <InputLabel shrink id="label-select-province">
                            Tipo de chave PIX
                          </InputLabel>
                          <Select
                            labelId="label-select-province"
                            id="pixType"
                            name="pixType"
                            label="Tipo de chave PIX *"
                            fullWidth
                            variant="standard"
                            placeholder="Selecione.."
                            value={pix.pixType}
                            onChange={(e, value) => {
                              formik.setFieldValue(
                                `pixs[${index}].pixType`,
                                e.target.value
                              );
                              formik.setFieldValue(`pixs[${index}].pixKey`, "");
                            }}>
                            <MenuItem value="CpfCnpj">CPF ou CNPJ</MenuItem>
                            <MenuItem value="Email">E-mail</MenuItem>
                            <MenuItem value="Telefone">Telefone</MenuItem>
                            <MenuItem value="Chave aleatória">
                              Chave aleatória
                            </MenuItem>
                            <MenuItem value="Copia e cola">
                              Copia e cola
                            </MenuItem>
                          </Select>
                        </Grid>
                        <Grid size={12}>
                          {(pix.pixType === "CpfCnpj" ||
                            pix.pixType === "Email" ||
                            pix.pixType === "Telefone") && (
                            <TextField
                              label="Chave PIX para depósito"
                              fullWidth
                              variant="standard"
                              value={pix.pixKey}
                              slotProps={{
                                htmlInput: {
                                  maxLength: 100,
                                },
                              }}
                              onChange={(e, value) => {
                                let pix = e.target.value;
                                const pixType =
                                  formik.values.pixs[index].pixType;
                                if (pixType === "CpfCnpj") {
                                  pix = formataChave(pix, "CpfCnpj");
                                } else if (pixType === "Telefone") {
                                  pix = formataChave(pix, "Telefone");
                                }

                                formik.setFieldValue(
                                  `pixs[${index}].pixKey`,
                                  pix
                                );
                              }}
                            />
                          )}
                          {(pix.pixType === "Copia e cola" ||
                            pix.pixType === "Chave aleatória") && (
                            <TextField
                              label="Chave PIX para transferência"
                              fullWidth
                              variant="standard"
                              value={pix.pixKey}
                              onChange={(e, value) => {
                                let pix = e.target.value;
                                formik.setFieldValue(
                                  `pixs[${index}].pixKey`,
                                  pix
                                );
                              }}
                            />
                          )}
                        </Grid>

                        <Grid
                          size={12}
                          sx={{ display: "flex", alignItems: "flex-end" }}>
                          <TextField
                            fullWidth
                            type="number"
                            name="amount"
                            autoComplete="off"
                            label="Valor do PIX"
                            onWheel={() => document.activeElement.blur()}
                            variant="standard"
                            value={pix.amount}
                            placeholder="R$ 0,00"
                            onChange={(e, value) => {
                              formik.setFieldValue(
                                `pixs[${index}].amount`,
                                formataValorSimulador(e.target.value)
                              );
                            }}
                            slotProps={{
                              inputLabelProps: {
                                shrink: true,
                              },
                              htmlInput: {
                                maxLength: 13,
                              },
                            }}
                          />
                          <ClearIcon
                            onClick={() => {
                              formik.setFieldValue(
                                `pixs`,
                                formik.values.pixs.filter(
                                  (pix, i) => i !== index
                                )
                              );
                            }}
                            sx={{
                              cursor: "pointer",
                              color: "action.active",
                              mx: 1,
                            }}
                          />
                        </Grid>

                        <Grid size={12} sx={{ m: 1 }}>
                          <Divider />
                        </Grid>
                      </Grid>
                    ))}
                  </>
                )}></FieldArray>
            </FormikProvider>
          </Paper>
        </Grid>
      )}
    </>
  );
}
